// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRiseOutlinedSvg from "@fishx/icons-svg/es/asn/PRiseOutlined";
import FishxIcon from '../components/FishxIcon';

var PRiseOutlined = function PRiseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRiseOutlinedSvg
  }));
};

PRiseOutlined.displayName = 'PRiseOutlined';
export default React.forwardRef(PRiseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRiseOutlined.js
// module id = 3597
// module chunks = 0